// extracted by mini-css-extract-plugin
export default {"customers":"lZ","wrapper":"mZ","carousel":"nZ","carousel_inner_wrapper":"oZ","top_quote":"pZ","bottom_quote":"qZ","carousel_wrapper":"rZ","feedbacks_wrapper":"sZ","arrows":"tZ","prev":"uZ","img":"vZ","review_btn":"wZ"};
    if(module.hot) {
      // 1715091684312
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  